import React, { useState, useCallback } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';
import RecoupAccountForm from './FormComponents/RecoupAccountForm';
import AlertToast from 'components/AlertToast';

import * as API from 'api';

import ViewWrapper from 'views/ViewWrapper';
const RecoupAccounts = API.RecoupAccounts();

const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
});
function CreateRecoupAccounts({ ...props }) {
  const history = useHistory();
  const { classes } = props;

  function goBack() {
    history.push('/recoupment-accounts');
  }

  async function saveRecoupAccount(formData) {
    return await RecoupAccounts.create(formData);
  }

  const [errorMessage, setErrorMessage] = useState('');

  const clearError = useCallback(() => {
    setErrorMessage(() => '');
  }, []);

  const onError = useCallback(error => {
    setErrorMessage(() => error.message);
  }, []);

  return (
    <ViewWrapper>
      <AlertToast message={errorMessage} onClear={clearError} />
      <MuiPaper className={classes.paper}>
        <MuiGrid container spacing={1}>
          <MuiGrid item xs={12}>
            <MuiTypography variant="h6">Create Recoupment Account</MuiTypography>
          </MuiGrid>
          <RecoupAccountForm goBack={goBack} saveRecoupAccount={saveRecoupAccount} onError={onError} />
        </MuiGrid>
      </MuiPaper>
    </ViewWrapper>
  );
}

export default withStyles(styles)(CreateRecoupAccounts);
